import { Component, inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { InterviewStreamService } from './services/interview.service'
import { InterviewDataService } from './services/interview-data.service'
import { CountdownComponent, CountdownEvent } from 'ngx-countdown';
import { BackendService } from '../../common/services/backend.service';
import { Question } from '../../models/Question';
import { Interview } from '../../models/Interview';
import{ VgApiService } from "@videogular/ngx-videogular/core";
import { TranslateService } from '@ngx-translate/core';

declare var window:any;
@Component({
    selector: 'interview',
    templateUrl: './interview.component.html',
    standalone: false
})

export class InterviewComponent {

    private _dataService = inject(InterviewDataService);
    private _backendService = inject(BackendService);
    private _videoService = inject(InterviewStreamService);
    private _route = inject(Router);
    private _activatedRoute = inject(ActivatedRoute);
    private translate = inject(TranslateService);


    @ViewChild('playback', {static:false}) playback: any;
    @ViewChild('questiontimer', {static: false}) questionTimer: CountdownComponent;
    @ViewChild('responsetimer', {static: false}) responseTimer: CountdownComponent;
    @ViewChild('stopRecordingBtn') stopRecordingBtn: any;
    @ViewChild('nextQuestionBtn') nextQuestionBtn: any;

    api: VgApiService;
    interview: Interview;
    currentItem: any;
    currentIndex: number = 0;
    recording: boolean = false;
    startResponse: boolean = false;
    questionFinished: boolean = false;
    enableStopRecording: boolean = false;
    videos: any;
    questionProgress: any;
    questionIndex: any;
    questionTotal: any;
    questions: Question[];
    id: any;
    stream: any;
    els:any;
    radius:any;
    circumference:any;
    currentCount:number = 0;
    maxCount:number;
    questionTimerConfig = { leftTime: 30, format: 'm:ss', notify: 0, demand: true };
    intervalId:any;
    data:any = {};
    duration:any;
    subscription:any;
    loading:any = false;
    done:any = false;
    showTimer:any = false;
    answers: any;
    videoSubscription: any;
    apiSubscription: any;
    interviewStarted: any;
    rerecordAnswerMessage:string;


    private _showQuestion: boolean = true;

    get showQuestion(): boolean {
        if (this.recording || this.questionFinished) {
            return this._showQuestion;
        }
        return true;
    }

    set showQuestion(value: boolean) {
        this._showQuestion = value;
    }

    get timerColorClass(): string {
        const total = this.recording ? this.maxCount : this.questionTimerConfig.leftTime;
        const remaining = total - this.currentCount;
        const pct = remaining / total;
        if (pct <= 0.10) return 'bg-error';
        if (pct <= 0.25) return 'bg-warn';
        return '';
    }

    ngOnInit() {
        this._activatedRoute.params.subscribe((params) => {
            this._dataService.interviewId = params['id'];
            this._dataService.practice = this._activatedRoute.snapshot.queryParamMap.get('practice') || false;
            this.videoSubscription = this._videoService.currentStream.subscribe(video => {
                this.stream = video;
            });
            this.startInterview();
        });
    }

    startInterview() {
        if (window.parent.USER_TYPE === 'student') {
            this.data.video_interview_id = this._dataService.interviewId;
            this.data.status = "incomplete";
            this.data.student = window.parent.CURRENT_USER;
            this._dataService.saveAttempt(this.data);
        }
        this._dataService.getInterview();
        this.subscription = this._dataService.interview.subscribe((resp:any) => {
            if (resp) {
                this.interview = resp;
                this.questions = this.interview['questions'];
                this.loadQuestion();
            }
        });
    }

    onPlayerReady(api: VgApiService) {
        this.api = api;
        let media = this.api.getDefaultMedia().subscriptions;
        this.apiSubscription = media.loadedMetadata.subscribe(this.playVideo.bind(this));
        media.ended.subscribe(this.playResponse.bind(this));
    }

    playVideo() {
        this.api.play();
    }

    playResponse() {
        this.startResponse = true;
        this.stream.play();
        this.currentCount = 0;
        this.startTimer(this.questionTimer);
    }

    onQuestionTimerEvent(event: CountdownEvent) {
        this.currentCount = Math.round((this.questionTimerConfig.leftTime * 1000 - event.left) / 1000);
        this.startRecording(event);
    }

    startTimer(timer: CountdownComponent) {
        timer.begin();
    }

    stopTimer(timer: CountdownComponent) {
        timer.stop();
    }

    resetTimer(timer: CountdownComponent) {
        timer.restart();
        timer.pause();
    }

    startRecording(event?: CountdownEvent) {
        if (event && event.action !== 'done') {
            return;
        }
        this._showQuestion = false;
        this.enableStopRecording = false;
        this.loading = true;
        this.rerecordAnswerMessage = '';
        this.questionFinished = false;
        this.api.pause();
        this.stopTimer(this.questionTimer);
        this._videoService.start();
        setTimeout(() => {
            this.intervalId = setInterval(this.startCountdown.bind(this), 1000);
            setTimeout(() => {
                this.enableStopRecording = true;
                setTimeout(() => this.stopRecordingBtn?.nativeElement?.focus(), 50);
            }, 7000);
        }, 2000);
    }

    stopRecording(event?: CountdownEvent) {
        if (event && event.action !== 'done') {
            return;
        }
        this._videoService.stopVideo(this.stream);
        let wrapperId = this.questions[this.currentIndex].question_wrapper_id;
        let next = !!this.questions[this.currentIndex + 1];
        this._videoService.start();
        this._dataService.saveAnswer(wrapperId).subscribe((resp) => {
            this.stopCountdown();
            if (resp) {
                if (!next) {
                    this.done = true;
                    this.interviewComplete();
                } else {
                    this.questionFinished = true;
                    setTimeout(() => this.nextQuestionBtn?.nativeElement?.focus(), 50);
                }
            }
        }, err => {
            this.stopCountdown();
            this.recording = false;
            this.rerecordAnswerMessage = 'interviews.RerecordMessage'
            // ensures record answer button state is correct before starting the timer
            setTimeout(() => {
                this.startTimer(this.questionTimer);
            }, 1000);
        });
    }

    loadQuestion() {
        this.showTimer = false;
        this._videoService.stopVideo(this.stream);
        this._videoService.setStreamName();
        this.currentItem = this.questions[this.currentIndex];
        this.maxCount = this.currentItem.response_duration;
        setTimeout(() => {
            this.showTimer = true;
        }, 150);
        this.startResponse = false;
        this.questionFinished = false;
        this.recording = false;
        this.getStepProgress();
        this.duration = this.maxCount / 60;
        if (this.playback) {
            this.playback.nativeElement.src = this.currentItem.question_file;
        }
        this._showQuestion = true;
        document.title = `${this.translate.instant('interviews.Question')} ${this.translate.instant('interviews.Current of Total', { current_row: this.questionIndex, total_rows: this.questionTotal })}`;
        document.querySelector<HTMLElement>('h2.question-title')?.focus();
    }

    loadNextQuestion() {
        this.currentIndex += 1;
        this.loadQuestion();
    }

    interviewComplete() {
        if (this._dataService.practice) {
            this._route.navigate(['../practice-complete'], {relativeTo: this._activatedRoute});
            return;
        }
        if (window.parent.USER_TYPE == 'student') {
            this.data.status = "completed";
            this._backendService.update(this._dataService.attemptId, 'video-interview-attempt', this.data)
                .subscribe(data => {
                    this._route.navigate(['../interview-complete'], {relativeTo: this._activatedRoute});
                });
        }
    }

    getStepProgress() {
        this.questionIndex = this.currentIndex + 1;
        this.questionTotal = this.questions.length;
        this.questionProgress = (this.questionIndex / this.questionTotal) * 100;
    }

    startCountdown() {
        this.recording = true;
        this.loading = false;
        if (this.responseTimer) {
            this.startTimer(this.responseTimer);
            if (this.currentCount > this.maxCount) {
                clearInterval(this.intervalId);
                return;
            }
        }
        this.currentCount++;
    }

    stopCountdown() {
        this.recording = false;
        clearInterval(this.intervalId);
        this.stopTimer(this.responseTimer);
        this.resetTimer(this.responseTimer);
        this.currentCount = 0;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.videoSubscription.unsubscribe();
        this.apiSubscription.unsubscribe();
        this._videoService.stopVideo(this.stream);
    }
}
